<div class="row pad">
  <div class="col-1"><img src="../assets/cvx-80x80.png" alt="Chevron" /></div>
  <div class="col-1"></div>

  <div class="col-8 divCenterFlex">
    <h1 class="divCenterFlex">
      Weld Manager Tool
      <span class="red" style="font-family: 'GothamBold', 'Helvetica Neue', Helvetica, Arial, sans-serif; margin-left: 0.5rem">{{ showEnvironment() }}</span>
    </h1>
  </div>

  @if (userName.length > 0) {
    <div class="col-2 center-vert">
      <span class="user"
        >{{ userName }}<br />
        Site: {{ refineryName }}<br /></span
      ><em class="pi pi-user user"></em>
      <!-- Theme toggle -->
      <div class="theme-toggle-container">
        <span>
          <button class="theme-toggle btn-span" (click)="toggleTheme()" title="Toggle theme">
            <i class="pi" [class.pi-moon]="isDarkTheme" [class.pi-sun]="!isDarkTheme"></i>
            <span class="theme-label">{{ isDarkTheme ? 'Dark' : 'Light' }}</span>
          </button></span
        >
      </div>
      <!-- </div> -->
    </div>
  }
</div>

<div class="navbar">
  <div>
    @if (validatePermissions('view weld log')) {
      <span class="btn-span" (click)="routePage('/log')">Weld Log</span>
    }
  </div>

  <!-- <div class="navbar"> -->
  <div>
    @if (validatePermissions('view welder qualification')) {
      <span class="btn-span" (click)="routePage('/welder-qualification')">Welder Qualification</span>
    }
  </div>
  <!-- <div class="navbar"> -->
  <div>
    @if (validatePermissions('view welder continuity')) {
      <span class="btn-span" (click)="routePage('/continuity')">Welder Continuity</span>
    }
  </div>
  <!-- #region Reporting -->
  <div class="col-2 d-flex justify-content-center">
    <span class="btn-span" (click)="reportingMenu.toggle($event)">Reporting</span>
    <p-tieredMenu #reportingMenu [model]="reportingMenuItems" [popup]="true" appendTo="body"></p-tieredMenu>
  </div>
  <!-- #endregion -->
  <div>
    @if (validatePermissions('system admin')) {
      <span class="btn-span" (click)="adminMenu.toggle($event)">Admin</span>
    }
    <p-tieredMenu #adminMenu [model]="adminMenuItems" [popup]="true" appendTo="body"></p-tieredMenu>
  </div>
  <!-- Help is always far right, regardless of what options user has above -->
  <!-- <div style="grid-column: 5/6"> -->
  <div>
    <span class="btn-span" (click)="menu.toggle($event)">Help</span>
    <p-tieredMenu #menu [model]="menuItems" [popup]="true" appendTo="body"></p-tieredMenu>
  </div>
</div>
